<template>
  <Teleport to="#toast">
    <div
      class="fixed inset-x-20 top-0 mt-20 flex flex-col items-center gap-12 md:inset-x-auto md:left-0 md:m-20 md:transform-none md:items-start ltr:md:left-0 rtl:md:right-0"
      :style="{ zIndex: toastZIndex }"
    >
      <JToast
        v-for="{ id, title, color } in store.toasts"
        :key="id"
        :title="title"
        :color="color as BGColors"
        @close="store.removeToast(id)"
      />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { BGColors } from '@journey/ui-kit'
import { JToast, openPopups, useZIndex } from '@journey/ui-kit'
import useToastStore from '@/modules/Core/store/toast'

defineOptions({
  name: 'AppToasts',
})

const store = useToastStore()
const { getNewZIndex } = useZIndex()

const toastZIndex = computed(() => {
  return store.toasts.length + openPopups.value.length + getNewZIndex()
})
</script>
